import ContactInfo from './ContactInfo'
import ProfileOverview from './ProfileOverview'

import classes from './InfoPanel.module.scss'
import PropTypes from 'prop-types'

const InfoPanel = ({ student }) => (
  <>
    <ProfileOverview student={student} />
    <div className={classes.divider} />
    <ContactInfo
      fullName={student.fullName}
      email={student.email}
      familyAdminsNames={student.familyAdminsNames}
      familyAdminsEmails={student.familyAdminsEmails}
      phone={student.phone}
    />
  </>
)

InfoPanel.propTypes = {
  student: PropTypes.shape({
    fullName: PropTypes.string,
    birthdate: PropTypes.string,
    gender: PropTypes.number,
    email: PropTypes.string,
    phone: PropTypes.string,
    familyAdminsEmails: PropTypes.array,
    familyAdminsNames: PropTypes.array,
  }),
}

export default InfoPanel
